// extracted by mini-css-extract-plugin
export default {"scriptInstructions":"BusinessDashboard_scriptInstructions__TDGxa"};